import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import {
  CREATE_EXPENSE,
  GET_ALL_EMPLOYEES,
  GET_ALL_EXPENSE_TYPES,
  GET_ALL_EXPENSES,
  GET_ROUTES,
  GET_SUM_EXPENSES,
  UPDATE_EXPENSE,
} from 'apis/GraphQL/Queries/expensesQuery';
import {
  EXPENSES_VARIABLES,
  ICreateExpense,
  IGetAllEmployees,
  IGetAllExpenses,
  IGetRoutes,
  IGetSumExpenses,
  IUpdateExpense,
} from 'apis/GraphQL/Variables/expenses';

export const ExpensesApis = {
  getAllExpenses: (params: IGetAllExpenses) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_ALL_EXPENSES,
      variables: EXPENSES_VARIABLES.getAllExpenses(params),
    });
  },
  getSumExpenses: (params: IGetSumExpenses) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_SUM_EXPENSES,
      variables: EXPENSES_VARIABLES.getSumExpenses(params),
    });
  },
  getAllEmployees: (params: IGetAllEmployees) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_ALL_EMPLOYEES,
      variables: EXPENSES_VARIABLES.getAllEmployees(params),
    });
  },
  getAllExpensesType: () => {
    return axiosGraphQL.post('/graphql', {
      query: GET_ALL_EXPENSE_TYPES,
      variables: EXPENSES_VARIABLES.getAllExpensesType(),
    });
  },
  createExpense: (params: ICreateExpense) => {
    return axiosGraphQL.post('/graphql', {
      query: CREATE_EXPENSE,
      variables: EXPENSES_VARIABLES.createExpenses(params),
    });
  },
  updateExpenses: (params: IUpdateExpense) => {
    return axiosGraphQL.post('/graphql', {
      query: UPDATE_EXPENSE,
      variables: EXPENSES_VARIABLES.updateExpenses(params),
    });
  },
  getRoutes: (params: IGetRoutes) => {
    return axiosGraphQL.post('/graphql', {
      query: GET_ROUTES,
      variables: EXPENSES_VARIABLES.getRoutes(params),
    });
  },
};
